import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App';
import CssBaseline from '@mui/material/CssBaseline';
import { initSentry } from './utils/sentry';
import './utils/sentryTest'; // 테스트 함수 로드
import './utils/priceDataDebugger'; // 🔧 가격 데이터 디버거 로드
import './scripts/migrateToCanonicalIds'; // 🔑 ID 마이그레이션 스크립트 로드
import './scripts/migrateWearables'; // 🎧 웨어러블 전용 마이그레이션 스크립트
import './scripts/migrateTablets'; // 📱 태블릿 전용 마이그레이션 스크립트
import './scripts/migrateSmartphones'; // 📱 스마트폰 전용 마이그레이션 스크립트

// Sentry 초기화
initSentry();

// Sentry로 감싸진 App 컴포넌트
const SentryApp = Sentry.withErrorBoundary(App, {
  fallback: ({ error, resetError }) => (
    <div style={{ 
      padding: '2rem', 
      textAlign: 'center',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        background: 'white',
        padding: '3rem',
        borderRadius: '1rem',
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>😵</div>
        <h2 style={{ 
          color: '#dc3545', 
          marginBottom: '1rem',
          fontSize: '1.5rem',
          fontWeight: '700'
        }}>
          서비스에 일시적인 문제가 발생했습니다
        </h2>
        <p style={{ 
          color: '#6c757d', 
          marginBottom: '2rem',
          lineHeight: '1.6'
        }}>
          문제가 자동으로 신고되었으며, 빠른 시간 내에 해결하겠습니다.<br/>
          불편을 드려 죄송합니다.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <button 
            onClick={resetError}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '0.5rem',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '600',
              transition: 'background-color 0.2s'
            }}
          >
            다시 시도하기
          </button>
          <button 
            onClick={() => window.location.href = '/'}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '0.5rem',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '600',
              transition: 'background-color 0.2s'
            }}
          >
            홈으로 가기
          </button>
        </div>
      </div>
    </div>
  ),
  beforeCapture: (scope, error) => {
    scope.setTag("errorBoundary", true);
    scope.setLevel('fatal');
    
    // 에러 발생 페이지 정보 추가
    scope.setContext("page_info", {
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString()
    });
    
    console.error('🚨 Fatal Error caught by Error Boundary:', error);
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CssBaseline />
    <SentryApp />
  </React.StrictMode>
);